<template>
  <div v-if="recipes.length > 0" class="similar-recipes-container mt-4">
    <h4 class="mb-3">Похожие рецепты</h4>
    <div class="recipes-scroll-list">
      <RecipeCardPopular
        v-for="recipe in recipes"
        :key="recipe.id"
        :recipe="recipe"
        @show-full-recipe="handleShowFullRecipe"
      />
    </div>
  </div>
  <div v-else-if="isLoading" class="text-center mt-4">
    <div class="spinner-border text-secondary" role="status">
      <span class="visually-hidden">Загрузка похожих рецептов...</span>
    </div>
  </div>
</template>

<script>
import RecipeCardPopular from "./RecipeCardPopular.vue";

export default {
  name: "SimilarRecipes",
  components: {
    RecipeCardPopular,
  },
  props: {
    recipeId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      recipes: [],
      isLoading: false,
      error: null,
    };
  },
  watch: {
    recipeId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchSimilarRecipes(newId);
        }
      },
    },
  },
  methods: {
    async fetchSimilarRecipes(recipeId) {
      this.isLoading = true;
      this.error = null;
      this.recipes = [];
      try {
        const limit = 10;
        const command = `recipe.getSimilar/${recipeId}/${limit}`;
        const response = await this.sendCmd(command);
        const parsedResponse = JSON.parse(response);
        const unpackedJsonString = await this.unpackData(parsedResponse.data);
        this.recipes = JSON.parse(unpackedJsonString);
      } catch (err) {
        this.error = "Не удалось загрузить похожие рецепты.";
        console.error("Error fetching similar recipes:", err);
      } finally {
        this.isLoading = false;
      }
    },
    handleShowFullRecipe(recipe) {
      // Navigate to the new recipe page
      window.location.hash = `/recipes/${recipe.id}`; // `/recipes/${recipe.id}`;
    },
  },
};
</script>

<style scoped>
.similar-recipes-container {
  padding-top: 1rem;
  border-top: 1px solid var(--bs-border-color-translucent);
}
.recipes-scroll-list {
  display: flex;
  overflow-x: auto;
  gap: 1rem;
  padding-bottom: 1rem; /* For scrollbar visibility */
  scrollbar-width: thin;
  scrollbar-color: var(--bs-secondary-bg) var(--bs-body-bg);
}

/* Hide scrollbar for a cleaner look, but still allow scrolling */
.recipes-scroll-list::-webkit-scrollbar {
  height: 8px;
}
.recipes-scroll-list::-webkit-scrollbar-thumb {
  background-color: var(--bs-secondary-bg);
  border-radius: 4px;
}
</style>
